/*
 * Filename: d:\projects\AutoFiFront\src\Content\CarImgSlider\CarImgSlider.tsx
 * Path: d:\projects\AutoFiFront
 * Created Date: Friday, January 13th 2023, 2:10:45 pm
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */

import { useEffect, useState } from "react";
import styles from "Content/Car/CarImgSlider/CarImgSlider.module.css";
import { CarImgSliderPropsType } from "Content/Car/CarImgSlider/CarImgSliderProps.type";
import translator from "MultiLanguage/TranslationWrapper";
import ServiceGeneral from "Services/ServiceGeneral";

function CarImgSlider (props: CarImgSliderPropsType) {
    const [firstPicture, setFirstPicture] = useState(`/PH${props.subSection}.svg`);

    useEffect(() => {
        const url = `${props.url}/0`;
        ServiceGeneral.manageCall(url, "get").then((result) => {
            setFirstPicture(result.data.Pict.URI);
        }).catch((error) => {
            console.log(error);
        });
    }, []);

    return (
        <div className={`${styles.imgSlider}`}>
            {
                props.status.toLowerCase() === "sold" ? <div className={`${styles.sold}`}> <p>{translator.decode("car.sold")}</p> </div> : null
            }
            {
                props.status.toLowerCase() === "reserved" ? <div className={`${styles.reserved}`}> <p>{translator.decode("car.reserved")}</p> </div> : null
            }
            <img className={styles.CarImgSlider} src={firstPicture} alt={firstPicture}/>
        </div>
    );
};

export default CarImgSlider;
